<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M5.75 4C4.7835 4 4 4.7835 4 5.75V10.25C4 11.2165 4.7835 12 5.75 12H10.25C11.2165 12 12 11.2165 12 10.25V5.75C12 4.7835 11.2165 4 10.25 4H5.75Z"
    fill="currentColor"
  />
</svg>
